import {Icon, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** Group-header row content for the Sollapay-managed system access section of the team table. */
export const TeamSystemAccessGroupHeader: FC = () => {
  const {t} = useTranslation('team');

  return (
    <div className="flex items-center gap-2">
      <Icon name="shield" width={13} height={13} className="text-fg-tertiary" />
      <Typography size="xs" weight="semibold" color="secondary">
        {t('systemAccessGroup.label')}
      </Typography>
      <Typography size="xs" color="tertiary" className="ms-auto hidden lg:inline">
        {t('systemAccessGroup.helperText')}
      </Typography>
    </div>
  );
};
